module.exports = __webpack_public_path__ + "static/img/brand.e459245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/brand.png
// module id = aaIl
// module chunks = 1